import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  Container,
  Grid,
  makeStyles
} from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import Page from 'src/components/Page';
import Toolbar from './Toolbar';
import ImageCard from './ImageCard';
import ImageService from '../../../services/ImageService';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  ImageCard: {
    height: '100%'
  }
}));

const ImageList = () => {
  const classes = useStyles();
  const { id } = useParams();
  const [images, setImages] = useState([]);

  const foo = async () => {
    const fetchData = typeof id !== 'undefined'
      ? await ImageService.getById(id)
      : await ImageService.getAll();

    if (fetchData?.code === 200) {
      if (id) {
        setImages([fetchData.data]);
      } else {
        setImages(fetchData.data);
      }
    }
  };

  useEffect(() => {
    foo();
  }, []);

  useEffect(() => {
    if (id && id?.length > 0) {
      foo();
    }
  }, [id]);

  return (
    <Page
      className={classes.root}
      title="Imágenes"
    >
      <Container maxWidth={false}>
        <Toolbar />
        <Box mt={3}>
          <Grid
            container
            spacing={3}
          >
            {images.map((image) => (
              <Grid
                item
                key={image?.id}
                lg={6}
                md={4}
                xs={12}
              >
                <ImageCard
                  className={classes.ImageCard}
                  image={image}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box
          mt={3}
          display="flex"
          justifyContent="center"
        >
          <Pagination
            color="primary"
            count={3}
            size="small"
          />
        </Box>
      </Container>
    </Page>
  );
};

export default ImageList;
